// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase */
import Price from "@kiwicom/frontend-common/records/Price"

import {
  AxaInsurancePassengerOffersInput,
  AxaInsurancePassengerOffers,
} from "../../../scenes/BookingAncillary/consts/types"

export default function mapperAxaInsuranceOffers(
  ancillary: AxaInsurancePassengerOffersInput,
): AxaInsurancePassengerOffers {
  return ancillary.offers.map(({ passenger_id, meta }) => ({
    passengerId: passenger_id,
    options: meta.options.map(({ level, price }) => ({
      [level]: Price.fromServer(price),
    })),
  }))
}
